import { render, staticRenderFns } from "./MainTop.vue?vue&type=template&id=1d2921b6&scoped=true"
import script from "./MainTop.vue?vue&type=script&lang=js"
export * from "./MainTop.vue?vue&type=script&lang=js"
import style0 from "./MainTop.vue?vue&type=style&index=0&id=1d2921b6&prod&lang=css"
import style1 from "./MainTop.vue?vue&type=style&index=1&id=1d2921b6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d2921b6",
  null
  
)

export default component.exports